/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    Shopify.theme.jsIconWitheText = {
      init: function ($section) {
  
        // Add settings from schema to current object
        Shopify.theme.jsIconWitheText = $.extend(this, Shopify.theme.getSectionData($section));
  
        let $sliderEl = $($section).find('[data-slider]');
  
        if(!isScreenSizeLarge()) {
          this.createSlider($sliderEl);
        }
        
      },
      createSlider: function ($sliderEl) {
  
        const slideData = {
          products_per_slide: this.products_per,
          products_available: this.products_available,
          products_limit: this.products_limit,
        }
  
        const slider = $sliderEl.flickity({
          lazyLoad: 2,
          freeScroll: false,
          groupCell:true,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'left',
          wrapAround: false,
          pageDots: true,
          contain: true,
          prevNextButtons: false,
          initialIndex: 0,
          arrowShape: arrowShape,
          on: {
            ready: function() {
              // Resize flickity when the slider is settled
              $sliderEl.on( 'settle.flickity', function() {
                $sliderEl.flickity('resize')
              });
            },
            scroll: function(progress){
                var progressBar = $sliderEl.parent().find('.progress-bar')
                progress = Math.max( 0, Math.min( 1, progress ) );
                $(progressBar).css('width',progress * 100 + '%')
    
            }
          }
        });
       
        slider.on('settle.flickity', function () {
          slider.flickity('resize');
        });
  
      },
      unload: function ($section) {
        let $slider = $section.find('.flickity-enabled');
        $slider.flickity('destroy');
      }
    }
  
    /******/
  })()
    ;